/* eslint-disable react/no-danger */
export default function Token(props) {
  const { tokenJson = {}, intid, devId, mcid, isDeviceMobile } = props?.data?.data || {};

  const tokenString = `
  var tokenJson = ${JSON.stringify(tokenJson)};
  var intid = "${intid || ''}";
  var mmt = {};
  mmt.hlp = {};
  var devId = "${devId}";
  var mcid = "${mcid}";
  var device = "${!isDeviceMobile ? 'desktop' : 'mobile'}";
  if(tokenJson.src_city_code){
    var isDom = (tokenJson.src_country_code == 'IN') ? 'Y' : 'N';
    var prefilledSrcCity = '{"country":"'+ tokenJson.src_country_name + '","iata":"'
        + tokenJson.src_city_code + '","iata_label":"'
        + tokenJson.src_city_name + ', '+ tokenJson.src_country_name + ' ('
        + tokenJson.src_city_code + ')","isDom":"'+isDom+'","fph_cd_s":"'
        + tokenJson.src_city_code + '","city":"'
        + tokenJson.src_city_name + '","fph_cty_s":"'+ tokenJson.src_country_code + '"}';
    }
  if(tokenJson.dest_city_code){
    var isDomDest = (tokenJson.dest_country_code == 'IN') ? 'Y' : 'N';
    var prefilledDestCity = '{"country":"'+ tokenJson.dest_country_name + '","iata":"'
        + tokenJson.dest_city_code + '","iata_label":"'
        + tokenJson.dest_city_name + ', '+ tokenJson.dest_country_name + ' ('
        + tokenJson.dest_city_code + ')","isDom":"'+isDomDest+'","fph_cd_s":"'
        + tokenJson.dest_city_code + '","city":"'
        + tokenJson.dest_city_name + '","fph_cty_s":"'+ tokenJson.dest_country_code + '"}';
  }
  var pageType = 'home', WEBSITE_URL = '//www.makemytrip.com', funnel_URL = '', mouseRecorder = '', serverTodayDate = new Date(), serverTime = new Date(), noOfDaysToAddInDept = ${tokenJson?.noOfDaysToAddInDept || ''}, noOfDaysToAddInReturn = ${tokenJson?.noOfDaysToAddInReturn || ''};
  `;
  return (
    <>
      <script dangerouslySetInnerHTML={{ __html: tokenString }} />
    </>
  );
}
